import React, { memo } from 'react';
import { DESC, ListWithoutStoringParams } from 'framework/list';
import GroupedApplicationListCollapse, {
  GroupedApplicationListCollapseProps,
} from 'domain/recruiting/applications/List/GroupedApplicationList/GroupedApplicationListCollapse';
import useApplicationService from 'domain/recruiting/applications/shared/applicationService';

interface GroupedApplicationsListGroupProps extends GroupedApplicationListCollapseProps {
  index: number;
}

const GroupedApplicationsListGroup = memo(({ stage, index, filter, search }: GroupedApplicationsListGroupProps) => {
  const { searchWithFormattedFilters } = useApplicationService();

  return (
    <ListWithoutStoringParams
      getDataMethod={params => searchWithFormattedFilters({ ...params, groupedBy: index })}
      defaultSortOrder={DESC}
      defaultSortField="candidateApplication.createdAt"
      defaultFilter={filter}
      pageSize={15}
    >
      <GroupedApplicationListCollapse filter={filter} stage={stage} search={search} />
    </ListWithoutStoringParams>
  );
});

export default GroupedApplicationsListGroup;
